import React, { useState } from 'react';
import Topbar from '../components/Topbar';
import EmptyState from '../components/EmptyState';
import { useApp } from '../context/AppContext';
import { Copy, CheckCircle2, Eye } from 'lucide-react';

const statusColor = (s) => s === 'DELIVERED' ? 'text-[#22c55e]' : s === 'PENDING' ? 'text-[#f59e0b]' : s === 'REFUNDED' ? 'text-[#8a8a8a]' : 'text-[#8a8a8a]';

const MyOrders = ({ onDeposit }) => {
  const { orders } = useApp();
  const [openId, setOpenId] = useState(null);
  const [copied, setCopied] = useState('');

  const copy = (v, id) => { navigator.clipboard.writeText(v); setCopied(id); setTimeout(() => setCopied(''), 1500); };

  return (
    <div>
      <Topbar count={orders.length} title="MY ORDERS" subtitleUnit="Records" onDeposit={onDeposit} />
      <div className="px-8 py-6">
        {orders.length === 0 ? (
          <EmptyState variant="orders" title="NO ORDERS YET" subtitle="Your delivered subscriptions & keys will appear here." />
        ) : (
          <div className="border border-[#151515] rounded-md overflow-hidden font-mono">
            <div className="grid grid-cols-[150px_1.5fr_1fr_1fr_1fr_100px] px-4 py-3 text-[10px] tracking-[0.25em] text-[#5a5a5a] border-b border-[#151515] bg-[#080808]">
              <div>ORDER ID</div>
              <div>PRODUCT</div>
              <div>AMOUNT</div>
              <div>DATE</div>
              <div className="text-right">STATUS</div>
              <div className="text-right">ACTION</div>
            </div>
            {orders.map((o) => (
              <React.Fragment key={o.id}>
                <div className="grid grid-cols-[150px_1.5fr_1fr_1fr_1fr_100px] px-4 py-3 text-[12px] border-b border-[#0f0f0f] last:border-0 items-center hover:bg-[#0d0d0d]">
                  <div className="text-[#22c55e]">{o.id}</div>
                  <div className="text-[#e6e6e6] uppercase truncate pr-3">{o.product_name}</div>
                  <div className="text-[#e6e6e6]">{o.currency === 'USDT' ? '$' : '₹'}{Math.abs(o.amount).toFixed(2)} <span className="text-[#5a5a5a] text-[10px]">{o.currency}</span></div>
                  <div className="text-[#8a8a8a]">{o.created_at}</div>
                  <div className={`text-right tracking-[0.2em] ${statusColor(o.status)}`}>{o.status}</div>
                  <div className="text-right">
                    {o.status === 'DELIVERED' && (
                      <button onClick={() => setOpenId(openId === o.id ? null : o.id)} className="text-[10px] tracking-[0.2em] text-[#22c55e] hover:underline inline-flex items-center gap-1">
                        <Eye size={12} /> KEY
                      </button>
                    )}
                  </div>
                </div>
                {openId === o.id && o.credential && (
                  <div className="px-4 py-3 bg-[#0d0d0d] border-b border-[#0f0f0f] flex items-start gap-3">
                    <div className="text-[10px] tracking-[0.25em] text-[#7a7a7a] w-[150px]">DELIVERED KEY</div>
                    <div className="flex-1 flex items-center justify-between gap-2 border border-[#1f1f1f] rounded-md px-3 py-2 bg-[#050505]">
                      <code className="text-[12px] text-[#22c55e] break-all whitespace-pre-wrap">{o.credential}</code>
                      <button onClick={() => copy(o.credential, o.id)} className="shrink-0 text-[#22c55e]">
                        {copied === o.id ? <CheckCircle2 size={14} /> : <Copy size={14} />}
                      </button>
                    </div>
                  </div>
                )}
              </React.Fragment>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default MyOrders;
